import { Component, Input, ViewChild } from '@angular/core';
import { StepperHelper } from '@app/_shared/helpers/StepperHelper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { SetIsLoading } from '../../store/stepper.actions';

@Component({
    selector: 'app-wizard-error-modal',
    templateUrl: './wizard-error-modal.component.html',
    styleUrls: ['./wizard-error-modal.component.scss'],
})
export class WizardErrorModalComponent {
    @Input() fromParent;

    constructor(public activeModal: NgbActiveModal, private store: Store, private stepperHelper: StepperHelper) {}

    ngOnInit() {}

    save() {
        this.store.dispatch(new SetIsLoading(false));
        this.stepperHelper.deleteStatusWizard();
        this.stepperHelper.goToFirstStep();
        this.activeModal.dismiss();
        window.location.reload();
    }
}
